export const environment = {
    version: '1.0.96.2024-04-02-17-55-07',
    production: false,
    secretKey: '$2y$10$SM9aIjPVrh1OHYSRfwtcfuB8vgMSK.76rcHuwekEIKypUN.9bgFFK',
    apiEndpoint: 'https://hosciapi.snt-mkt-automation.com/api'
};
